import React from 'react'

import { LSDiscountPath } from '../../../../assets/svgs/landingV2/guest'
import { LSAppImage } from '../../../../assets/images/landingV2/guest'
import './styles.scss'
import './responsiveStyles.scss'

function LoyaltySystem() {
  return (
    <div className='gl_ls'>
      <div className='gl_ls__container'>
        <div className='gl_ls__title'>
          <h1>Система лояльності</h1>
        </div>
        <div className='gl_ls__info'>
          <div className='gl_ls__info_left'>
            <img src={LSDiscountPath} alt='Loyalty system' />
            <p>Зроби перше замовлення і відразу отримуй перший рівень!</p>
            <p>Кожен рівень – це 1% знижки. Максимальна кількість рівнів – 10.</p>
          </div>
          <div className='gl_ls__info_right'>
            <img src={LSAppImage} alt='App image' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoyaltySystem
